import { Component } from '@angular/core';

@Component({
  selector: 'mojo-layout-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
}
